jQuery(function ($) {
    "use strict";

    if($(document).width() < 801){
      $('#close-menu').on('click', function(e){
          e.preventDefault();
          $('#header-menu').animate({ 'left': -300 });
      });
      $('#open-menu').on('click', function(e){
        e.preventDefault();
        $('#header-menu').animate({ 'left': 0 });
    });
    }

    $('.menu-item-has-children > ul').hide();
    $('.menu-item-has-children > a').on('click', function(e){
        e.preventDefault();
        $(this).parent().children('.sub-menu').slideToggle('slow');     
    });

    if($('.carrossel-clientes').length){
        $('.carrossel-clientes').slick({
            arrows: true,
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 580,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
            ]
        });
    }

    if($('.depoimentos-blockquote').length){
      $('.depoimentos-blockquote').slick({
          arrows: false,
          dots: true,
          infinite: true,
          speed: 300,
          slidesToShow: 2,
          autoplay: true,
          autoplaySpeed: 4000,
          responsive: [
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
      });
  }
    
    /* =Mask jQuery
    -------------------------------------------------------------- */
    $('.mask-date').mask('00/00/0000');
    $('.mask-time').mask('00:00:00');
    $('.mask-dateTime').mask('00/00/0000 00:00:00');
    $('.mask-cep').mask('00.000-000');
    $('#calc_shipping_postcode').mask('00000-000');
    $('.mask-cpf').mask('000.000.000-00');
    $('.mask-cnpj').mask('00.000.000/0000-00');
    $('.mask-money').mask('000.000.000.000.000,00', {reverse: true});
    var CelMaskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
        celOptions = {
            onKeyPress: function(val, e, field, options) {
                field.mask(CelMaskBehavior.apply({}, arguments), options);
            }
        };

    $('.mask-tel').mask(CelMaskBehavior, celOptions);

});